import GoodPriceTag from '../../../../../pages/vip/features/good-price-tag/good-price-tag';

export default GoodPriceTag;
